import uuid from 'react-uuid';

const CLIENT_ID_STORAGE_KEY = 'atoz-analytics-client-id';
const CLIENT_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

let clientId: string | undefined;
let cognitoId: string | undefined;

export function getClientId(): string {
    if (clientId) {
        return clientId;
    }

    try {
        const stored = window.localStorage.getItem(CLIENT_ID_STORAGE_KEY);
        clientId = stored && CLIENT_ID_PATTERN.test(stored) ? stored : uuid();
        if (clientId !== stored) {
            window.localStorage.setItem(CLIENT_ID_STORAGE_KEY, clientId);
        }
    } catch {
        clientId = uuid();
    }

    return clientId;
}

export function setCognitoId(id: string): void {
    cognitoId = id;
}

export function getCognitoId(): string | undefined {
    return cognitoId;
}

export function resetClientIdentity(): void {
    clientId = undefined;
    cognitoId = undefined;
}
